import React from "react";
import { Link, useLocation } from "react-router-dom"

function CNavLink({children, to, active = [], activeExact = [], onClick, disabled = false, ...props}) {

    // const match = useMatch(to) ? 'active' : ''
    const location = useLocation();

    const isActive = () => {
        return active.some(path => location.pathname.includes(path)) ||
            activeExact.some(path => location.pathname === path);
    };

    const match = isActive() ? 'active' : '';
    
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (onClick) {
            onClick(e);
        }
    };

  return (
    <li className={`${match}${disabled ? ' disabled' : ''}`}>
        <Link
            to={to}
            onClick={handleClick}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : undefined}
            {...props}
        >
            {children}
        </Link>
    </li>
  )
}

export {CNavLink}
